import React from 'react';
import { LanguageDropdown } from '@ghq-abi/design-system';
import { useTranslate } from '@tolgee/react';
import { LanguagesEnum } from 'abi-oneverse-common-types';

import { normalizeLanguage } from '~/shared/utils/string';

import { useLanguageDropdown } from './hooks';

type LanguageDropdownProps = {
    currentLanguage?: string;
};

export const LanguageDropdownHeader = ({ currentLanguage }: LanguageDropdownProps) => {
    const { t } = useTranslate();
    const { updateLanguage, currentLanguage: contextLanguage } = useLanguageDropdown();

    const languageOptions = Object.keys(LanguagesEnum).map((lang: string) => ({
        label: t(`languages.${lang}`),
        onSelect: () => updateLanguage(lang),
    }));

    const displayLanguage = normalizeLanguage(currentLanguage || contextLanguage);
    const userLanguageLabel = t(`languages.${displayLanguage}`);

    return <LanguageDropdown value={userLanguageLabel} items={languageOptions} />;
};
